import gql from 'graphql-tag';

export const LoomAuthStateQuery = gql`
	query LoomAuthStateQuery {
		loomUserStatus
	}
`;
